import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import AppRoutes from './components/AppRoutes';
import TermsOfUseMain from './pages/TermsOfUseMain';
import './App.css';

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/:tenantSlug/*"
          element={
            <Layout>
              <AppRoutes />
            </Layout>
          }
        />
        {/* Standalone Terms and Conditions route */}
        <Route
          path="/TermsAndConditions"
          element={
            <Layout>
              <TermsOfUseMain />
            </Layout>
          }
        />
        {/* Redirect root to a default tenant or show tenant selection */}
        <Route path="/" element={<Navigate to="/Sunrise" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
